import { createFeatureSelector, createSelector } from '@ngrx/store';
import {pageFeatureKey, PageState} from "../reducers/page.reducer";

export const selectPageFeature = createFeatureSelector<PageState>(
  pageFeatureKey
);

export const getSideMenuItems = () => createSelector(
  selectPageFeature,
  (state: PageState) => state.sideMenuItems
);

export const getLinkPrefix = () => createSelector(
  selectPageFeature,
  (state: PageState) => state.linkPrefix
);

export const getArchiveSortState = () => createSelector(
  selectPageFeature,
  (state: PageState) => state.showArchiveSort
);


